import appendImageUrlFromAPI from "./appendImageUrlFromAPI";

export default function linkImage(src: any): string {
  if (typeof src === "string") {
    // If it is a root-relative path (e.g. starting with '/') or full URL, return it directly
    if (src.startsWith("/") || src.startsWith("http")) {
      return src;
    }
    return appendImageUrlFromAPI({ src });
  }
  if (src && typeof src === "object" && src.src) {
    return src.src; // Next.js StaticImageData
  }
  return src || "";
}
